import moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'

export function scheduleStartDateFromUTC(startDate: string) {
  if (!startDate) {
    return undefined
  }

  return stringToDate(startDate, 'backend_datetime')
}

type ScheduleDates = {
  startDate?: string | null
  startTime?: string | null
}

export function scheduleStartDateToUTC(schedule: ScheduleDates) {
  if (!schedule.startDate || !schedule.startTime) {
    return undefined
  }

  const [hours, minutes] = schedule.startTime.split(':')

  return moment(schedule.startDate)
    .set({
      hours: Number(hours),
      minutes: Number(minutes),
    })
    .tz('UTC')
}
